import React, { useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FireboardChecksList from '@components/Fireboard';
import { getObjectValue } from '@utility/utills';
import { useOutletContext } from 'react-router-dom';
import {
  getDeliverTo,
  getOrderNameFromOrderId,
  getTimeInHrsMins,
  getCheckSourceIcon,
  getPaidStatusIcon,
  getCheckInTime,
  getModeIconBgColor,
  getFormattedOpenOrCloseDate,
} from '@utility/fireboardUtil';
import { LABEL } from '../../veriables';
import { getFormatedPhoneNumber } from '@utility/helperFunction';
import PropTypes from 'prop-types';
import { safeJsonParse } from '../../utility/helperFunction';

const Fireboard = props => {
  const { tableData, currentMode, notificationTableData, venueStores } = props;
  const storeInfo = safeJsonParse(window.sessionStorage.getItem('auth'), {});
  const currency = LABEL().CURRENCY_SYMBOL;

  const { supportsTipsOnTotalAmount = false, suppressTipsOnFireBoard = false } =
    storeInfo?.serverAppFeatures || {};
  const {
    currentView,
    selectedCheck,
    setSelectedCheck,
    filteredCheckListItem,
    checkFilters,
    updateOrderStatus,
    markOrderAsPickedUp,
    setPopup,
    popup,
    isFlip,
    setIsFlip,
    isExpanded,
    setIsExpanded,
    traceClick,
    setTraceClick,
    countryCode,
    futureOrdersSummary,
    setFilteredCheckListItem,
  } = useOutletContext();

  const getCheckStatus = check => {
    const statusWithColor = getOrderNameFromOrderId(check);
    return statusWithColor;
  };

  const getIconColor =
    currentView === 'listView' || currentMode === 'FUTURE_ORDERS'
      ? 'white'
      : 'var(--primary-icon-color)';

  const getModes = check => {
    const { sourceType, tab } = check || {};
    let delivery = false;
    let isMarketPlaceOrder = false;
    let isCatering = false;
    const imgSrc = getCheckSourceIcon(
      sourceType,
      getIconColor,
      delivery,
      isMarketPlaceOrder,
      isCatering,
      tab
    );
    return imgSrc;
  };

  const getModesBgColor = check => {
    const { sourceType, tab } = check || {};
    let delivery = false;
    let isMarketPlaceOrder = false;
    let isCatering = false;
    const bgColor = getModeIconBgColor(
      sourceType,
      delivery,
      isMarketPlaceOrder,
      isCatering,
      tab
    );
    return bgColor;
  };

  const getTimeInMilliSeconds = date => {
    if (!date) return 0;
    const convertedDate = date?.includes('Z')
      ? new Date(date)
      : new Date(date + 'Z');
    return convertedDate.getTime();
  };

  const getVenueStoresName = storeId => {
    const venuesInfoList = venueStores?.saStoreInfos;
    const storeFromVenue = venuesInfoList?.find(store => store.id === storeId);
    return venuesInfoList ? storeFromVenue?.name : storeInfo?.name;
  };

  const getFormattedCheck = check => {
    const AllItems = [
      ...(check?.Items ?? check?.items ?? []),
      ...(check?.PendingItems || []),
    ];
    const { paidIcon, preAuthIcon } = getPaidStatusIcon(check, currency);
    return {
      ...check,
      AllItems,
      checkNumber: check.checkNumber != null ? `[${check.checkNumber}]` : '- -',
      number: check.number,
      id: check.id,
      checkHeaderId: check.checkHeaderId,
      deliverTo: getDeliverTo(check),
      dueTime: getTimeInHrsMins(check.dueTimeDisplay),
      ellapsedTime: check.openDate,
      unFormattedPhoneNumber: check.phoneNumber,
      pickupDate: check.pickupDate,
      pickupDateInMS: getTimeInMilliSeconds(check.pickupDate),
      status: getCheckStatus(check),
      mode: getModes(check),
      modeBgColor: getModesBgColor(check),
      preAuthIcon: preAuthIcon,
      paid: preAuthIcon || paidIcon,
      checkInTime: getCheckInTime(check),
      checkInTimeForSorting: new Date(check.checkInDate).getTime(),
      phoneNumber: check.phoneNumber
        ? getFormatedPhoneNumber(check?.phoneNumber)
        : '- -',
      orderDetails: {
        orderName: check.name,
        phoneNumber: check.phoneNumber
          ? getFormatedPhoneNumber(check?.phoneNumber)
          : '---',
        isPhoneNumber: check.phoneNumber,
      },
      timeDetails: {
        ellapsedTime: check.openDate,
        dueDate: getTimeInHrsMins(check.dueTimeDisplay),
      },
      tableInfo: {
        tab: check.tab,
        stationName: check.stationName,
        stationNumber: check.stationNumber,
      },
      paymentDetails: {
        paidAmount: check.paidAmount,
        unpaidAmount: check.unpaidAmount,
      },
      openDateDetails: {
        openDate: getFormattedOpenOrCloseDate(check?.openDate),
        closeDate: getFormattedOpenOrCloseDate(check?.closeDate),
        ellapsedTime: check.openDate,
        ellapsedTimeColor: check.openDate,
      },
      guestDetails: {
        guestCount: check?.guestCount,
        phoneNumber: check.phoneNumber
          ? getFormatedPhoneNumber(check?.phoneNumber)
          : '---',
        isPhoneNumber: check.phoneNumber,
        countryCode: check?.orders[0]?.countryCode || countryCode,
      },
      remainingTimeDetails: {
        remainingTime: check?.pickupDate,
        dueDate: getTimeInHrsMins(check.dueTimeDisplay),
      },
      storeInfoDetails: {
        storeName: getVenueStoresName(check?.storeId),
      },
    };
  };

  const checksRowData = useMemo(() => {
    const rowData =
      Array.isArray(filteredCheckListItem) &&
      filteredCheckListItem.length &&
      filteredCheckListItem.map(check => getFormattedCheck(check));

    return rowData || [];
  }, [filteredCheckListItem, tableData]);

  return (
    <div className="col-12 px-0 h-100">
      <FireboardChecksList
        tableData={props.tableData}
        checksRowData={checksRowData}
        storeInfo={storeInfo}
        selectedCheck={selectedCheck}
        setSelectedCheck={setSelectedCheck}
        currency={currency}
        supportsTipsOnTotalAmount={supportsTipsOnTotalAmount}
        suppressTipsOnFireBoard={suppressTipsOnFireBoard}
        currentView={currentView}
        checkFilters={checkFilters}
        currentMode={currentMode}
        setPopup={setPopup}
        popup={popup}
        updateOrderStatus={updateOrderStatus}
        markOrderAsPickedUp={markOrderAsPickedUp}
        isFlip={isFlip}
        setIsFlip={setIsFlip}
        isExpanded={isExpanded}
        setIsExpanded={setIsExpanded}
        traceClick={traceClick}
        setTraceClick={setTraceClick}
        countryCode={countryCode}
        futureOrdersSummary={futureOrdersSummary}
        setFilteredCheckListItem={setFilteredCheckListItem}
        venueStores={venueStores}
      />
    </div>
  );
};

const mapStateToProps = ({
  storeNotifications,
  storeChecks,
  oauth,
  venue,
}) => ({
  notificationTableData: storeNotifications.storeNotification,
  tableData: { ...storeChecks.checkListHashTable },
  currentMode: oauth.currentMode,
  venueStores: venue.venueStores,
});
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

Fireboard.propTypes = {
  tableData: PropTypes.object,
  currentMode: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(Fireboard);
